import React from 'react';
import { Link } from 'react-router-dom';

// Styles
import styles from "./../UserManagment.module.css";

// Images
import ClockIcon from "./../../../../assets/img/DashboardICons/ClockIcon.svg";
import arrowBlue from "./../../../../assets/img/DashboardICons/ArrowLeftBlue.svg";

const UserManagmentRecordsAds = (props) => {

    return (
        <div dir="rtl" className={`pb-2`}>
            {
                props.recordAdsData?.map(adsData => (
                    <div key={adsData.id} className={`d-flex align-items-start justify-content-between mb-4 ${styles.total_table_records_box}`}>
                        <div className={`col-4 ${styles.title_subTitle_table_records_box}`}>
                            <h4 className={`${styles.title_table_records_box}`}> {adsData.title.replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d])} </h4>
                            <div>
                                <img src={ClockIcon} alt="time-upload-icon" width="17" />
                                <span className={`pe-1 ${styles.time_text_table_records_box}`}> {adsData.constructionDate.replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d])} </span>
                            </div>
                        </div>
                        <div className={`col-3 ${styles.type_table_records_box}`}>
                            <span className={`${styles.type_title_table_records_box}`}> نوع آگهی:  </span>
                            <span className={`pe-1 ${styles.type_text_table_records_box}`}> {adsData.meteragePrice === 0 ? "اجاره" : "فروش"} </span>
                        </div>
                        <div
                            style={{ backgroundColor: "#D9FFD2" }}
                            className={`d-flex align-items-center justify-content-center ${styles.status_table_records_box}`}
                        >
                            {
                                adsData.status.status === 1 ?
                                    " پیش نویس"
                                    :
                                    adsData.status.status === 2 ?
                                        "تایید شده"
                                        :
                                        adsData.status.status === 3 ?
                                            "غیرفعال"
                                            :
                                            adsData.status.status === 4 ?
                                                "در انتظار تایید"
                                                :
                                                adsData.status.status === 6 &&
                                                "رد شده"
                            }
                            {adsData.status === 2 ? "فعال" : "غیرفعال"}
                        </div>
                        <div className={`col-2`}>
                            <Link to={{
                                pathname: `/فایل/${adsData.slug}`,
                                state: {
                                    state: adsData
                                }
                            }} className={`me-auto ${styles.link_icon_text}`}>
                                مشاهده آگهی
                                <img className='me-2' src={arrowBlue} alt="arrow-blue-icon" width="12" />
                            </Link>
                        </div>
                    </div>
                ))
            }
        </div>
    )
}

export default UserManagmentRecordsAds